import { Button } from "antd";
import { useGetUserQuery } from "api/TenantSlug/User/hooks.ts";
import { ManageAffiliateForm } from "components/Forms/ManageAffiliateForm/ManageAffiliateForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerContent } from "components/UI/DrawerContent/DrawerContent.tsx";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models.ts";
import { getDrawerSearchParams } from "utils/drawerHelpers";

interface AffiliateDetailDrawerProps {
    affiliateId: string;
}

export const AffiliateDetailDrawer: FC<AffiliateDetailDrawerProps> = ({ affiliateId }) => {
    const { t: tCommon } = usePaldockTranslation("common");
    const id = DrawerId.AffiliateDetail;

    const { data } = useGetUserQuery(
        affiliateId,
        { filter: { include: "tenantSettings" } },
        {
            enabled: !!affiliateId,
            refetchOnMount: "always",
            staleTime: 0,
        }
    );
    const { user } = data || {};

    const extraButtons = (
        <Button size="large" type="primary" htmlType="submit" form={FormId.AddUserForm}>
            {tCommon("save")}
        </Button>
    );

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={user?.nickname ?? "---"} />}
            extraButtons={extraButtons}
            searchParamsToClean={getDrawerSearchParams(id, "affiliateId")}
        >
            <DrawerContent>
                <ManageAffiliateForm mode="detail" user={user} />
            </DrawerContent>
        </Drawer>
    );
};
